import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import { responseObj } from '../nest-model/nest-model';

/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WorkFlowApiProvider {

  module: string = 'workflow';
  model: string = 'workflow';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello AccessManagementProvider Provider');
  }

  showButton(requestNo: string) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "showButton";
    const params: any = {};
    const urlParams: any = { requestNo: requestNo };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<boolean>>(method, url, params, urlParams, body, contentType);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/workflow/workflow-api.ts